var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"__affirm-logo",class:[_vm.color === 'white' ? '__affirm-logo-white' : '__affirm-logo-blue'],style:({ height: _vm.height === 0 ? 'auto' : _vm.height + 'px' })},[_vm._v("Affirm")])}
var staticRenderFns = []

export { render, staticRenderFns }